import { useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { useVerifyEmail } from '../hooks/useAuth'
import { Wordmark } from '../components/ui/Wordmark'

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') ?? ''
  const verifyEmail = useVerifyEmail()

  useEffect(() => {
    if (token && verifyEmail.isIdle) {
      verifyEmail.mutate(token)
    }
  }, [token, verifyEmail])

  return (
    <div className="min-h-screen bg-bg flex flex-col items-center justify-center px-5 py-10">
      <div className="mb-7"><Wordmark size={22} /></div>

      <div className="bg-surface border border-line-soft rounded-[20px] px-9 py-8 w-full max-w-[400px] text-center">
        {!token && (
          <p className="m-0 text-[13px] text-[#A33A2A]">Invalid verification link.</p>
        )}

        {token && verifyEmail.isPending && (
          <p className="m-0 text-[13px] text-ink-2">Verifying your email…</p>
        )}

        {token && verifyEmail.isSuccess && (
          <>
            <div className="text-[40px] mb-3">✓</div>
            <h2 className="serif text-[28px] tracking-tight m-0 mb-2.5">Email verified!</h2>
            <p className="m-0 mb-6 text-[13px] text-ink-2 leading-[1.5]">
              Your email has been confirmed. You're all set.
            </p>
            <Link
              to="/"
              className="inline-flex items-center justify-center h-11 px-7 rounded-full bg-primary text-on-primary text-sm font-semibold no-underline"
            >
              Go to home
            </Link>
          </>
        )}

        {token && verifyEmail.isError && (
          <>
            <p className="m-0 mb-4 text-[13px] text-[#A33A2A] leading-[1.5]">
              This link is invalid or has expired.
            </p>
            <Link to="/login" className="text-primary text-[13px] font-semibold no-underline">
              Back to log in
            </Link>
          </>
        )}
      </div>
    </div>
  )
}
